import React, { useState, useEffect, useCallback } from "react";
import "./Testimonial.css";

const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    position: "CTO, TechSolutions Inc.",
    content:
      "MK E-Tech has transformed our IT infrastructure with their cutting-edge solutions. Their team delivered beyond our expectations with seamless implementation and excellent support.",
    rating: 5,
  },
  {
    id: 2,
    name: "Priya Sharma",
    position: "Director, Digital Innovations",
    content:
      "Working with MK E-Tech has been a game-changer for our digital transformation journey. Their expertise in emerging technologies is unmatched in the industry.",
    rating: 5,
  },
  {
    id: 3,
    name: "Amit Patel",
    position: "CEO, FinTech Systems",
    content:
      "The cybersecurity solutions provided by MK E-Tech have significantly enhanced our data protection. Their 24/7 support team is always responsive and knowledgeable.",
    rating: 4,
  },
  {
    id: 4,
    name: "Neha Gupta",
    position: "Head of IT, EduTech Global",
    content:
      "MK E-Tech's cloud migration services helped us reduce costs by 40% while improving performance. Their team is professional, efficient, and truly understands client needs.",
    rating: 5,
  },
  {
    id: 5,
    name: "Sanjay Verma",
    position: "Operations Manager, RetailChain",
    content:
      "The custom ERP solution developed by MK E-Tech has streamlined our operations across 50+ locations. Their attention to detail and post-implementation training was exceptional.",
    rating: 4,
  },
  {
    id: 6,
    name: "Ananya Desai",
    position: "VP Technology, HealthCare Plus",
    content:
      "MK E-Tech's AI-powered analytics platform revolutionized our patient care systems. Implementation was smooth and their ongoing support is top-notch.",
    rating: 5,
  },
  {
    id: 7,
    name: "Vikram Joshi",
    position: "Founder, GreenEnergy Tech",
    content:
      "As a startup, we needed cost-effective yet powerful solutions. MK E-Tech delivered exactly that with their scalable cloud infrastructure.",
    rating: 4,
  },
  {
    id: 8,
    name: "Meera Nair",
    position: "CIO, Banking Corporation",
    content:
      "The blockchain solutions implemented by MK E-Tech have made our transactions more secure and transparent. Their team's technical depth is impressive.",
    rating: 5,
  },
  {
    id: 9,
    name: "Rahul Khanna",
    position: "Head of Digital, AutoMakers Ltd",
    content:
      "MK E-Tech's IoT integration for our manufacturing plants has improved efficiency by 35%. Their solutions are both innovative and practical.",
    rating: 4,
  },
  {
    id: 10,
    name: "Sonia Kapoor",
    position: "Director, E-Commerce Giant",
    content:
      "Our website performance improved dramatically after MK E-Tech optimized our platform. Page load times decreased by 60% leading to higher conversions.",
    rating: 5,
  },
  {
    id: 11,
    name: "Arjun Reddy",
    position: "CTO, Logistics Network",
    content:
      "The route optimization algorithms developed by MK E-Tech saved us 20% in fuel costs. Their data science team is truly exceptional.",
    rating: 5,
  },
  {
    id: 12,
    name: "Nandini Iyer",
    position: "CEO, EduTech Startup",
    content:
      "MK E-Tech built our entire learning platform from scratch. They understood our vision perfectly and delivered ahead of schedule.",
    rating: 5,
  },
  {
    id: 13,
    name: "Kiran Bedi",
    position: "Head of IT, Government Services",
    content:
      "MK E-Tech's e-governance solutions have transformed citizen services in our department. Their secure systems handle millions of transactions daily without issues.",
    rating: 5,
  },
  {
    id: 14,
    name: "Ravi Shastri",
    position: "CTO, Sports Analytics",
    content:
      "The real-time data processing systems from MK E-Tech give us competitive edge during live matches. Their low-latency solutions are game-changing.",
    rating: 4,
  },
  {
    id: 15,
    name: "Deepika Menon",
    position: "Director, Media Conglomerate",
    content:
      "Our content delivery network optimized by MK E-Tech now handles 3x more traffic with zero downtime. Their infrastructure expertise is world-class.",
    rating: 5,
  },
  {
    id: 16,
    name: "Gautam Adhikari",
    position: "CIO, Manufacturing Group",
    content:
      "MK E-Tech's predictive maintenance systems reduced our equipment failures by 75%. Their industrial IoT solutions deliver measurable ROI.",
    rating: 5,
  },
  {
    id: 17,
    name: "Ishita Malhotra",
    position: "Head of Product, HealthTech",
    content:
      "The HIPAA-compliant systems developed by MK E-Tech accelerated our FDA approval process. Their compliance expertise saved us months of work.",
    rating: 5,
  },
  {
    id: 18,
    name: "Vishal Rao",
    position: "CEO, AgriTech Solutions",
    content:
      "MK E-Tech's satellite imaging and AI analysis helps farmers increase yields by 20-30%. Their agricultural technology is revolutionary.",
    rating: 4,
  },
  {
    id: 19,
    name: "Anjali Chawla",
    position: "CTO, Fashion Retail",
    content:
      "Our inventory management system developed by MK E-Tech reduced waste by 40% through better demand forecasting. Their retail solutions are transformative.",
    rating: 5,
  },
  {
    id: 20,
    name: "Rohan Mehra",
    position: "Director, Smart Cities Initiative",
    content:
      "MK E-Tech's urban monitoring systems help manage traffic, pollution and utilities across our city. Their smart city solutions are scalable and reliable.",
    rating: 5,
  },
  {
    id: 21,
    name: "Shweta Kapoor",
    position: "Head of AI Research, University",
    content:
      "Collaborating with MK E-Tech on our AI research projects has yielded breakthrough results. Their technical team brings both academic and practical expertise.",
    rating: 5,
  },
  {
    id: 22,
    name: "Aditya Nair",
    position: "CEO, SpaceTech Ventures",
    content:
      "MK E-Tech's ground station software processes our satellite data with incredible efficiency. Their aerospace solutions are truly out of this world.",
    rating: 5,
  },
  {
    id: 23,
    name: "Pooja Bhatt",
    position: "Head of Digital, TravelHub",
    content:
      "MK E-Tech's booking platform overhaul increased our conversion rate by 45%. Their UX design team created an intuitive interface that our customers love.",
    rating: 5,
  },
  {
    id: 24,
    name: "Rajat Mehta",
    position: "CIO, Insurance Partners",
    content:
      "The fraud detection system implemented by MK E-Tech has saved us millions by identifying suspicious claims. Their AI models keep improving with time.",
    rating: 4,
  },
  {
    id: 25,
    name: "Divya Srinivasan",
    position: "VP Engineering, FoodTech",
    content:
      "MK E-Tech's delivery route optimization reduced our average delivery time by 28 minutes. Their real-time tracking integration was flawless.",
    rating: 5,
  },
  {
    id: 26,
    name: "Kunal Shah",
    position: "CTO, Renewable Energy Corp",
    content:
      "The energy grid management system from MK E-Tech helped us integrate solar and wind power more efficiently. Their green tech solutions are impressive.",
    rating: 5,
  },
  {
    id: 27,
    name: "Maya Rao",
    position: "Director, Non-Profit Foundation",
    content:
      "MK E-Tech donated their services to build our donation platform, which has helped thousands. Their commitment to social impact is as strong as their technical skills.",
    rating: 5,
  },
  {
    id: 28,
    name: "Varun Deshpande",
    position: "Head of IT, LegalTech",
    content:
      "MK E-Tech's document analysis AI has reduced contract review time from hours to minutes. Their NLP capabilities are industry-leading.",
    rating: 4,
  },
  {
    id: 29,
    name: "Anika Banerjee",
    position: "CEO, Fashion Startup",
    content:
      "The AR virtual try-on solution developed by MK E-Tech increased our online sales by 65%. Their innovative approach to retail tech is remarkable.",
    rating: 5,
  },
  {
    id: 30,
    name: "Rishi Kapoor",
    position: "CTO, Music Streaming",
    content:
      "MK E-Tech's recommendation engine keeps our users engaged 40% longer. Their machine learning algorithms understand listener preferences perfectly.",
    rating: 5,
  },
  {
    id: 31,
    name: "Nikhil Joshi",
    position: "Head of Security, Financial Services",
    content:
      "MK E-Tech's quantum-resistant encryption implementation future-proofed our banking systems. Their cybersecurity team operates at the cutting edge of technology.",
    rating: 5,
  },
  {
    id: 32,
    name: "Tanvi Malhotra",
    position: "Director, VR Gaming Studio",
    content:
      "The latency optimization MK E-Tech achieved for our multiplayer VR platform eliminated motion sickness issues. Their real-time rendering expertise is unmatched.",
    rating: 5,
  },
  {
    id: 33,
    name: "Arun Prabhakar",
    position: "CIO, Pharmaceutical Giant",
    content:
      "MK E-Tech's drug discovery acceleration platform reduced our research cycle time by 30%. Their bioinformatics solutions bridge science and technology perfectly.",
    rating: 4,
  },
  {
    id: 34,
    name: "Ishaan Khatri",
    position: "CEO, Autonomous Vehicles",
    content:
      "The sensor fusion algorithms developed by MK E-Tech improved our object detection accuracy to 99.97%. Their work is paving the way for safer self-driving cars.",
    rating: 5,
  },
  {
    id: 35,
    name: "Priyanka Reddy",
    position: "CTO, Language Learning App",
    content:
      "MK E-Tech's speech recognition and natural language processing power our real-time translation features with 95% accuracy. Their AI understands linguistic nuances beautifully.",
    rating: 5,
  },
  {
    id: 36,
    name: "Rohit Agarwal",
    position: "Head of IT, Construction Tech",
    content:
      "The digital twin technology implemented by MK E-Tech helps us simulate building projects before construction begins, saving millions in potential errors.",
    rating: 4,
  },
  {
    id: 37,
    name: "Ananya Bose",
    position: "Director, Climate Research",
    content:
      "MK E-Tech's climate modeling systems process petabytes of environmental data to predict weather patterns with unprecedented accuracy. Their work is helping combat climate change.",
    rating: 5,
  },
  {
    id: 38,
    name: "Vivek Choudhary",
    position: "CTO, Sports Wearables",
    content:
      "The biometric analysis platform from MK E-Tech provides athletes with real-time performance metrics that have helped break world records. Their sensor technology is revolutionary.",
    rating: 5,
  },
  {
    id: 39,
    name: "Meghna Patel",
    position: "Head of AI, Customer Service",
    content:
      "MK E-Tech's conversational AI handles 80% of our customer inquiries with human-like understanding. Their NLP models continuously learn and improve from interactions.",
    rating: 4,
  },
  {
    id: 40,
    name: "Aditi Rao",
    position: "CEO, Space Tourism",
    content:
      "The life support systems simulation software developed by MK E-Tech is crucial for our passenger spacecraft. Their aerospace engineering team thinks decades ahead.",
    rating: 5,
  },
  {
    id: 41,
    name: "Aarav Sharma",
    position: "Head of Robotics, Industrial Automation",
    content:
      "MK E-Tech's robotic process automation reduced our factory's production errors by 92% while tripling output. Their industrial AI solutions are manufacturing game-changers.",
    rating: 5,
  },
  {
    id: 42,
    name: "Neha Kapoor",
    position: "CTO, Mental Health Tech",
    content:
      "The emotion recognition algorithms MK E-Tech developed for our therapy app can detect subtle mood changes with 89% accuracy, helping prevent crises before they occur.",
    rating: 5,
  },
  {
    id: 43,
    name: "Rajat Verma",
    position: "Director, Smart Farming",
    content:
      "MK E-Tech's soil analysis drones and AI-powered irrigation system reduced our water usage by 40% while increasing crop yields. Their agri-tech innovations are feeding the future.",
    rating: 4,
  },
  {
    id: 44,
    name: "Anika Desai",
    position: "CEO, Accessibility Tech",
    content:
      "The eye-tracking interface MK E-Tech created has given thousands of mobility-impaired users complete computer control. Their inclusive design approach changes lives daily.",
    rating: 5,
  },
  {
    id: 45,
    name: "Vikram Chaturvedi",
    position: "Head of Blockchain, FinTech",
    content:
      "MK E-Tech's decentralized finance platform processes 15,000 transactions per second with zero downtime. Their distributed ledger technology is redefining global finance.",
    rating: 5,
  },
  {
    id: 46,
    name: "Priyanka Nair",
    position: "CTO, Disaster Response",
    content:
      "MK E-Tech's predictive analytics warned us about flood risks 72 hours before traditional systems, saving countless lives. Their humanitarian tech work is literally lifesaving.",
    rating: 5,
  },
  {
    id: 47,
    name: "Arjun Mehra",
    position: "Director, Smart Home Tech",
    content:
      "The energy optimization AI MK E-Tech implemented across our smart home devices reduced average household consumption by 35%. Their IoT solutions make sustainability effortless.",
    rating: 4,
  },
  {
    id: 48,
    name: "Divya Bhatia",
    position: "Head of R&D, Beauty Tech",
    content:
      "MK E-Tech's skin analysis algorithms power our virtual try-on with 98% color accuracy. Their computer vision transforms cosmetic shopping experiences.",
    rating: 5,
  },
  {
    id: 49,
    name: "Rahul Iyer",
    position: "CIO, Logistics Automation",
    content:
      "MK E-Tech's warehouse robotics system fulfills orders 8x faster with 99.9% accuracy. Their fulfillment center technology revolutionized our operations overnight.",
    rating: 5,
  },
  {
    id: 50,
    name: "Sonia Reddy",
    position: "CEO, Ocean Conservation",
    content:
      "The marine ecosystem monitoring AI developed by MK E-Tech tracks endangered species across 5,000 square miles of ocean. Their conservation tech protects our planet's future.",
    rating: 5,
  },
  {
    id: 51,
    name: "Kabir Malhotra",
    position: "CTO, Digital Twin Cities",
    content:
      "MK E-Tech's urban simulation platform models traffic flow, emergency responses, and infrastructure needs for entire metropolitan areas with startling accuracy.",
    rating: 4,
  },
  {
    id: 52,
    name: "Ananya Joshi",
    position: "Head of AI, Recruitment Tech",
    content:
      "MK E-Tech's bias-free hiring algorithms diversified our candidate pool by 300% while finding better qualified applicants. Their ethical AI sets the industry standard.",
    rating: 5,
  },
  {
    id: 53,
    name: "Rohan Kapoor",
    position: "Director, Space Mining",
    content:
      "The asteroid composition analysis system from MK E-Tech helps identify trillions in mineral resources. Their space tech makes the impossible possible.",
    rating: 5,
  },
  {
    id: 54,
    name: "Meera Nambiar",
    position: "CTO, Neurotechnology",
    content:
      "MK E-Tech's brain-computer interface allows paralyzed patients to control devices with 95% accuracy using just their thoughts. Their neuro-engineering is medical magic.",
    rating: 5,
  },
  {
    id: 55,
    name: "Vishal Rao",
    position: "Head of IT, Fusion Energy",
    content:
      "MK E-Tech's plasma containment simulation software accelerated our clean energy research by years. Their physics-based modeling is unlocking unlimited power.",
    rating: 5,
  },
  {
    id: 56,
    name: "Dr. Sanjay Varma",
    position: "Director, Genomic Research Institute",
    content:
      "MK E-Tech's AI-powered genome sequencing platform reduced our DNA analysis time from weeks to hours while maintaining 99.99% accuracy. Their bioinformatics solutions are revolutionizing personalized medicine.",
    rating: 5,
  },
  {
    id: 57,
    name: "Aisha Khan",
    position: "CTO, Smart Textiles",
    content:
      "The flexible electronics integration MK E-Tech developed for our smart fabrics withstands 500+ wash cycles while maintaining perfect functionality. Their wearable technology is fashion-forward and durable.",
    rating: 4,
  },
  {
    id: 58,
    name: "Rahul Bajaj",
    position: "Head of Innovation, Automotive Tech",
    content:
      "MK E-Tech's vehicle-to-everything (V2X) communication system prevents 92% of potential intersection collisions. Their automotive safety tech is setting new industry benchmarks.",
    rating: 5,
  },
  {
    id: 59,
    name: "Nalini Rao",
    position: "CEO, Cultural Heritage Preservation",
    content:
      "Using MK E-Tech's 3D scanning and digital archiving solutions, we've preserved 200+ endangered historical sites with millimeter precision. Their conservation technology protects our shared heritage.",
    rating: 5,
  },
  {
    id: 60,
    name: "Arjun Kapoor",
    position: "CTO, Drone Delivery Network",
    content:
      "MK E-Tech's air traffic control AI manages our fleet of 5,000+ delivery drones with zero incidents. Their autonomous navigation systems are the most reliable in the industry.",
    rating: 5,
  },
  {
    id: 61,
    name: "Dr. Priya Chatterjee",
    position: "Head of Surgical Robotics",
    content:
      "MK E-Tech's haptic feedback systems give our surgical robots a sense of touch accurate to 10 microns. Their medical technology enables procedures previously considered impossible.",
    rating: 5,
  },
  {
    id: 62,
    name: "Vikram Seth",
    position: "Director, Quantum Computing",
    content:
      "MK E-Tech's error correction algorithms extended our quantum processor coherence time by 300%. Their quantum innovations are accelerating the next computing revolution.",
    rating: 4,
  },
  {
    id: 63,
    name: "Anjali Mehta",
    position: "CEO, Voice Tech",
    content:
      "MK E-Tech's emotional speech synthesis creates the most natural digital voices that convey subtle human emotions perfectly. Their vocal AI is indistinguishable from humans.",
    rating: 5,
  },
  {
    id: 64,
    name: "Rajiv Malhotra",
    position: "Head of R&D, Battery Tech",
    content:
      "MK E-Tech's battery management AI extended our solid-state battery lifespan by 400% while charging 3x faster. Their energy storage solutions are electrifying the industry.",
    rating: 5,
  },
  {
    id: 65,
    name: "Sanya Joshi",
    position: "CTO, Digital Fashion",
    content:
      "The real-time fabric simulation MK E-Tech created for our virtual clothing uses advanced physics engines that perfectly mimic material behavior. Their digital twin tech is wearing the future.",
    rating: 5,
  },
  {
    id: 66,
    name: "Aditya Rao",
    position: "Director, Exoskeleton Tech",
    content:
      "MK E-Tech's motion control algorithms make our industrial exoskeletons move with natural human grace while lifting 200kg loads. Their biomechatronics redefine human potential.",
    rating: 4,
  },
  {
    id: 67,
    name: "Dr. Nandini Patel",
    position: "Head of Nanomedicine",
    content:
      "MK E-Tech's nanoparticle tracking system allows us to monitor drug delivery at cellular level with unprecedented precision. Their medical imaging breakthroughs are saving lives.",
    rating: 5,
  },
  {
    id: 68,
    name: "Kabir Khan",
    position: "CTO, Holographic Tech",
    content:
      "The light field displays MK E-Tech developed create holograms viewable from any angle without glasses. Their visual technology is making science fiction a reality.",
    rating: 5,
  },
  {
    id: 69,
    name: "Meena Krishnan",
    position: "Director, Smart Materials",
    content:
      "MK E-Tech's shape-memory alloy programming allows our architectural materials to adapt to weather conditions automatically. Their responsive materials are building the future.",
    rating: 5,
  },
  {
    id: 70,
    name: "Rishi Kapoor",
    position: "Head of AI Ethics",
    content:
      "MK E-Tech's fairness auditing framework ensures our AI systems make equitable decisions free from bias. Their responsible AI tools set the gold standard for ethical technology.",
    rating: 5,
  }
];

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleNext = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setIsAutoPlaying(true);
    
    setCurrentIndex(prevIndex => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
    
    setTimeout(() => setIsTransitioning(false), 800);
  }, [isTransitioning]);

  const handlePrev = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setIsAutoPlaying(true);
    
    setCurrentIndex(prevIndex => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
    
    setTimeout(() => setIsTransitioning(false), 800);
  }, [isTransitioning]);

  const goToSlide = useCallback((index) => {
    if (isTransitioning || index === currentIndex) return;
    setIsTransitioning(true);
    setIsAutoPlaying(true);
    
    setCurrentIndex(index);
    setTimeout(() => setIsTransitioning(false), 800);
  }, [isTransitioning, currentIndex]);

  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(handleNext, 6000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isAutoPlaying, handleNext]);

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <span 
        key={i} 
        className={`star ${i < rating ? "filled" : ""}`}
        style={{ 
          transitionDelay: `${i * 0.1}s`,
          animation: i < rating ? 'starPop 0.5s ease-out' : 'none'
        }}
      >
        {i < rating ? "★" : "☆"}
      </span>
    ));
  };

  return (
    <div className="testimonial-slider-container">
      <h2 className="testimonial-title">What Our Clients Says</h2>
      <p className="testimonial-subtitle">
        Trusted by industry leaders worldwide
      </p>

      <div className="slider-wrapper">
        <button 
          className="slider-arrow left-arrow" 
          onClick={handlePrev}
          aria-label="Previous testimonial"
        >
          <span className="arrow-icon">←</span>
        </button>
        
        <div className="slider-track-wrapper">
          <div 
            className="slider-track"
            style={{ 
              transform: `translateX(-${currentIndex * 100}%)`,
              transition: isTransitioning ? 'transform 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55)' : 'none'
            }}
          >
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id}
                className={`slide ${index === currentIndex ? 'active' : ''}`}
              >
                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <p className="quote-text">"{testimonial.content}"</p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-info">
                      <h4 className="author-name">{testimonial.name}</h4>
                      <div className="rating">
                        {renderStars(testimonial.rating)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <button 
          className="slider-arrow right-arrow" 
          onClick={handleNext}
          aria-label="Next testimonial"
        >
          <span className="arrow-icon">→</span>
        </button>
      </div>

      <div className="slider-dots">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to testimonial ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Testimonial;